<template>
  <div id="MatchResultsContent">
    <Modal @close="back()">
      <template slot="body">
        <div class="points" v-if="isDraw">
          <h1>La partita è finita in PAREGGIO!</h1>
          <h3>Questo vuol dire che i punti della prossima partita saranno DOPPI!</h3>
        </div>
        <div class="matchResult" v-else>
          <div class="team winners">
            <div class="points winner-points" >{{ points }}</div>
            <div class="players">
              <div class="player" v-for="player in winnerPlayers"
                v-bind:key="player.id">
                <Player :player="player"></Player>
              </div>
            </div>
          </div>
          <div class="team loosers">
            <div class="points looser-points" >{{ 120 - points }}</div>
            <div class="players" v-if="!isDraw">
              <div class="player" v-for="player in looserPlayers"
                v-bind:key="player.id">
                <Player :player="player" :looser="true"></Player>
              </div>
            </div>
          </div>
        </div>
        <div class="classifica">
          <table>
            <thead>
              <th v-for="(column, index) in table.users" :key="'player' + (index+1)"><p>{{ column.name }}</p></th>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in table.users[0].scores"
                v-bind:key="index">
                <td v-for="player in table.users" :key="player.id">{{ player.scores[index] }}</td>
              </tr>
              <tr class="total">
                <td v-for="player in table.users" :key="player.id">tot: {{ player.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Player from "@/components/ResultPlayer";
import Modal from "@/components/Modal";
import { mapGetters } from "vuex";

export default {
  name: "MatchResults",
  components: {
    Player,
    Modal
  },
  computed: {
    ...mapGetters({ 
      winnerPlayers: "results/winnerPlayers",
      looserPlayers: "results/looserPlayers",
      points: "results/points",
      isDraw: "results/isDraw",
      totals: "results/totals",
      calledPoints: "call/calledPoints",
      game: "game/game",
      me: "game/me", 
      table: "tables/tableActive",
    })
  },
  methods: {
    back() {
      this.$store.commit("call/resetCall");
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
.matchResult {
  display: flex;
  justify-content: space-around;
}
.players {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 0.5em;
}
.team {
  margin-bottom: 1em;
}
@keyframes blink { 
   50% { 
    border: 7px dashed lightseagreen;
    border-radius: 25px; 
    } 
}
.winners {
    border: dashed 5px black;
    animation-name: blink ;
    animation-duration: .5s ;
    animation-timing-function: step-end ;
    animation-iteration-count: infinite ;
    animation-direction: alternate ;
    display: inline-table;
    border: 7px dashed black;
}

.points {
  color: black;
  font-size: 30px;
  font-weight: 700;
  margin-top: 0.5em;
}
.winner-points{
  color: yellow;
  font-size: 40px;
}
.looser-points {
  color: firebrick;
}
.player {
  margin: 1em;
}
.classifica {
  display: flex;
  justify-content:center;
  font-size: 20px;
  font-weight: 900;
  height: 80%;
  overflow:auto;
}
table {
  font-weight: 600;
  border: solid 3px darkslategrey;
  border-collapse: collapse;
  width: 80%;
  padding: 5px;
  background-color: azure;
  margin-left: auto;
  margin-right: auto;
}
th,
td {
  padding: 5px;
  border: solid 1px rgb(77, 126, 126);
  text-align: center;
}
tr:nth-child(even) {
  background-color: rgb(170, 236, 236);
}
.total {
  font-weight: 900;
  background-color: rgba(77, 126, 126, 0.6) !important;
}
@media all and (min-width: 540px) and (max-width: 800px) {
  table{
    font-size: 12px;
  }
  .player {
    margin: 0.4em;
}
}
@media all and (max-height: 860px) {
  .points {
    font-size: 16px;
    font-weight: 700;
  }
  .classifica {
    font-size: 14px;
  }
  .form-button {
    margin: 0.5em;
    padding: 0.5em;
  }
}
@media all and (max-width: 540px) {
  table{
    font-size: 12px;
  }
  p {
    writing-mode: vertical-rl;
    text-orientation:sideways;
    line-height: 100%;
  }
  .player {
    margin: 0.2em;
  }
  .winners {
    width: inherit;
  }
}

</style>
